module.exports = __webpack_public_path__ + "img/placeholder_lote_hotel_ttttt.f12341a1.png";